
import $ from 'jquery';

import Zoom from '../utils/Zoom';
import VariantHelper from '../utils/VariantHelper';
import ImagePreloader from '../utils/ImagePreloader';

export default class ProductDetails {
  constructor(instance) {
    this.$el = $(instance.el);

    this.$productForm = $('[data-product-form]', this.$el);
    this.formID = this.$productForm.attr('data-product-form');
    this.processing = false;
    this.$productSlideshowNavigation = $('.product-slideshow-navigation', this.$el);

    // Form selectors
    this.productForm = `product-form-${this.formID}`;
    this.$productThumbnails = $('.product-thumbnails', this.$el);
    this.$productImage = $('.product-big-image', this.$el);
    this.$addToCartButton = $('.add-to-cart input', this.$el);
    this.$priceArea = $('.product-price', this.$el);
    this.$productMessage = $('[data-product-message]', this.$el);

    // Setup product information
    const $productJSON = $(`[data-product-json-${this.formID}]`, this.$el);
    const $productSettings = $(`[data-product-settings-${this.formID}]`, this.$el);

    if (!$productJSON.length) { return; }

    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    this.$variantDropdowns = $(`[data-option-select=${this.formID}]`, this.$el);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;

    this.$el
      .on('click', '.product-slideshow-pagination-item', event => this.updateProductImage(event))
      .on('submit', '.product-form', event => this.addToCart(event))
      .on('click', '.product-tabs-header-item', event => this.tabs(event))
      .on('click', '.product-slideshow-navigation', event => this.navigate(event))
      .on('click', '.number-input-nav-item', event => this.amount(event));
    this.$productSlideshowNavigation.on('mouseout.productSlideshow', event => $(event.currentTarget).blur());

    if (this.productSettings.imageZoom) {
      this.zoomView = new Zoom({ el: this.$productImage });
    }

    if (this.$variantDropdowns.length) {
      this.setupVariants();
    }

    this.cacheImages();

    // Watchers / Bound Events
    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  prepareRemove() {
    this.unload();
    this.$productSlideshowNavigation.off('mouseout.productSlideshow');
    if (this.variantHelpers) {
      this.variantHelpers.prepareRemove();
    }
    if (this.zoomView) {
      this.zoomView.prepareRemove();
      this.zoomView.remove();
    }
  }

  setupVariants() {
    const dropdownSettings = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      $selector: this.$variantDropdowns,
      formID: this.formID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
      type: 'select',
    };

    this.variantHelpers = new VariantHelper(dropdownSettings);
  }

  cacheImages() {
    if (this.productJSON.images.length) {
      new ImagePreloader(this.productJSON.images, '2048x2048');
      new ImagePreloader(this.productJSON.images, '600x600');
    }
  }


  updateProductImage(e, index) {
    if (e) { e.preventDefault(); }

    this.$el.find('.product-slideshow-pagination-item.active').removeClass('active');

    const $target = e ? $(e.currentTarget) : this.$el.find('.product-thumbnails .product-slideshow-pagination-item').eq(index);

    const newSrc = $target.data('default-res');
    $target.addClass('active');

    this.$el.find('[data-product-main-image]')
      .removeAttr('width height')
      .removeClass('product-no-images')
      .attr({
        src: newSrc,
        srcset: newSrc,
        alt: $target.data('alt'),
        'data-high-res': $target.data('high-res'),
      });

    if (this.productSettings.imageZoom) {
      setTimeout(() => this.$productImage.trigger('prepare-zoom'),
        200);
    }
  }

  addToCart(e) {
    if (this.productSettings.cartRedirect) { return; }

    e.preventDefault();

    if (this.processing) { return; }
    this.processing = true;

    this.$el.find('.add-to-cart').addClass('loading');

    const quantity = this.$el.find("input[name='quantity']").val();

    if ((quantity === '') || (quantity === '0')) {
      setTimeout(() => {
        this.$el.find("input[name='quantity']")
          .addClass('error');
        this.$productMessage
          .text(this.productSettings.setQuantityText);
        this.$el.find('.add-to-cart')
          .removeClass('loading added-success')
          .addClass('added-error');
        this.processing = false;
      },
      500);
    } else {
      Shopify.addItemFromForm(this.productForm, cartItem => setTimeout(() => {
        Shopify.getCart(cart => $('.cart-link .cart-count').text(cart.item_count));

        const successMessage = this.productSettings.successMessage.replace('** product **', `<em>${cartItem.title}</em>`);

        this.$productMessage.html(successMessage);
        this.$el.find("input[name='quantity']")
          .removeClass('error');
        this.$el.find('.add-to-cart')
          .removeClass('loading added-error')
          .addClass('added-success');
        $('.header-cart-count').addClass('active');

        this.$addToCartButton.val(this.productSettings.addToCartText);

        this.processing = false;
      },
      1000));
    }
  }

  handleErrors(errors) {
    const errorMessage = $.parseJSON(errors.responseText);
    const productTitle = this.productJSON.title;

    let errorDescription = errorMessage.description;
    if ((errorMessage.description ? errorMessage.description.indexOf(productTitle) : -1) > -1) {
      errorDescription = errorDescription.replace(productTitle, `<em>${productTitle}</em>`);
    }

    if (errorMessage.message === 'Cart Error') {
      setTimeout(() => {
        this.$el.find("input[name='quantity']").removeClass('error');
        this.$productMessage.html(errorDescription);
        this.$el.find('.add-to-cart').removeClass('loading added-success').addClass('added-error');

        this.$addToCartButton.val(this.productSettings.addToCartText);

        this.processing = false;
      },
      1000);
    }
  }

  tabs(e) {
    const target = $(e.currentTarget).attr('data-tab');
    const bodyTarget = $(e.currentTarget).parents('.product-tabs').find(`#${target}`);
    $(e.currentTarget).addClass('active').siblings().removeClass('active');
    return bodyTarget.addClass('active').siblings().removeClass('active');
  }

  navigate(e) {
    let target;
    if (e) { e.preventDefault(); }

    const total = this.$el.find('.product-slideshow-pagination-item').length - 1;
    const index = this.$el.find('.product-slideshow-pagination-item.active').index();

    if ($(e.currentTarget).hasClass('product-slideshow-next')) {
      if (index === total) {
        target = 0;
      } else {
        target = this.$el.find('.product-slideshow-pagination-item.active').next().index();
      }
    } else {
      if (index === 0) {
        target = total;
      } else {
        target = this.$el.find('.product-slideshow-pagination-item.active').prev().index();
      }
    }

    this.updateProductImage(false, target);
  }

  amount(e) {
    const input = $(e.currentTarget).parents('.number-input-wrapper').find('input');
    const result = parseFloat(input.val());
    if ($(e.currentTarget).hasClass('icon-plus')) {
      input.val(result + 1);
    }
    if ($(e.currentTarget).hasClass('icon-minus') && result > 0) {
      input.val(result - 1);
    }
  }

  unload() {
    this.$el
      .off('click', '.product-slideshow-pagination-item')
      .off('submit', '.product-form')
      .off('click', '.product-tabs-header-item')
      .off('click', '.product-slideshow-navigation')
      .off('click', '.number-input-nav-item');

    this.$productSlideshowNavigation.off('mouseout.productSlideshow');
  }
}
